import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { getEnv } from "./helpers/env";

const root = ReactDOM.createRoot(document.getElementById("root"));

const googleOAuth2ClientId = getEnv("REACT_APP_GOOGLE_OAUTH2_CLIENT_ID");

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleOAuth2ClientId}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
